import React from "react";
import {connect} from "react-redux";

import classNames from 'classnames'

import {formatPrice} from "../../helpers/price";

import './index.scss';

const TotalInfo = (props) => {

  const componentClass = classNames('total-info', props.className);

  let {totalPrice} = props;
  totalPrice = totalPrice || 0;

  let realPrice = (totalPrice + totalPrice * 0.4).toFixed();
  realPrice = realPrice - realPrice % 100 + 99;

  return (

    <div className={componentClass}>

      <div className="total-info__item total-info__item--primary">
        <div className="total-info__text">Ladenpreis</div>
        <div className="total-info__value">{realPrice} €
          <span className="total-info__value-prefix">Preise inkl. MwSt.</span>
        </div>

      </div>

      <div className="total-info__item total-info__item--secondary">
        <div className="total-info__text">Dein Herstellerpreis</div>
        <div className="total-info__value">
          {formatPrice(totalPrice, false)} €
        </div>
      </div>

    </div>
  )

};

export default connect(
  state => ({
    totalPrice: state.totalPrice,
  })
)(TotalInfo);
